import { relations } from 'drizzle-orm'
import {
  date,
  integer,
  pgEnum,
  pgTable,
  text,
  unique,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getIdReference,
  getMonetaryField,
  getNullableIdReference,
  getTimestampWithTimezone,
} from '../common/utils'
import { opportunities } from './opportunity'
import { properties } from './property'
import { servicePackageVersions } from './servicePackage'
import { visits } from './visit'

export const subscriptionStatusEnum = pgEnum('subscription_status', [
  'proposal',
  'active',
  'paused',
  'cancelled',
])

export const subscriptionStatusValues = subscriptionStatusEnum.enumValues

export const subscriptions = pgTable(
  'subscriptions',
  {
    ...getBaseFields(),
    propertyId: getIdReference(() => properties.id),
    opportunityId: getNullableIdReference(() => opportunities.id),
    displayName: text(),
    startDate: date().notNull(),
    endDate: date(),
    status: subscriptionStatusEnum().notNull().default('proposal'),
    stripeSubscriptionId: text().unique(),
    basePriceMonthly: getMonetaryField(),
    effectivePriceMonthly: getMonetaryField(),
    additionalTerms: text(),
    termsAcceptedAt: getTimestampWithTimezone(),
    termsVersion: text(),
  },
  (table) => getBaseIndexes('subscriptions', table),
)

// Junction table for subscriptions and package versions (many-to-many capable)
export const subscriptionPackageVersions = pgTable(
  'subscription_package_versions',
  {
    ...getBaseFields(),
    subscriptionId: getIdReference(() => subscriptions.id),
    servicePackageVersionId: getIdReference(() => servicePackageVersions.id),
    quantity: integer().notNull().default(1),
    sortOrder: integer().notNull().default(0),
  },
  (table) => ({
    ...getBaseIndexes('subscription_package_versions', table),
    uniqueSubscriptionPackage: unique().on(
      table.subscriptionId,
      table.servicePackageVersionId,
    ),
  }),
)

export const subscriptionsRelations = relations(
  subscriptions,
  ({ one, many }) => ({
    property: one(properties, {
      fields: [subscriptions.propertyId],
      references: [properties.id],
    }),
    opportunity: one(opportunities, {
      fields: [subscriptions.opportunityId],
      references: [opportunities.id],
    }),
    subscriptionPackageVersions: many(subscriptionPackageVersions),
    visits: many(visits),
  }),
)

export const subscriptionPackageVersionsRelations = relations(
  subscriptionPackageVersions,
  ({ one }) => ({
    subscription: one(subscriptions, {
      fields: [subscriptionPackageVersions.subscriptionId],
      references: [subscriptions.id],
    }),
    servicePackageVersion: one(servicePackageVersions, {
      fields: [subscriptionPackageVersions.servicePackageVersionId],
      references: [servicePackageVersions.id],
    }),
  }),
)
